import { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { API, get } from "../../../config";

export const getOfficeDetail = async (officeId) => {
  try {
    const { data } = await get(`${API.OFFICE}/` + officeId);
    return data.data;
  } catch (e) {
    return null;
  }
};

export const getOfficePopupDetail = async (officeId, isRecentActivity) => {
  try {
    if (isRecentActivity) {
      const { data } = await get(`${API.GET_OFFICE}/${officeId}`);
      return data.data;
    } else {
      const { data } = await get(`${API.GET_OFFICE}/${officeId}`);
      return data.data;
    }
  } catch (e) {
    const { data } = e.response;
    if (data) {
      toast.error(data?.message);
      toast.error(
        data.errors && data.errors.myna_error && data.errors.myna_error[0]
      );
    }
    return null;
  }
};

export const useStateList = () => {
  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const init = useCallback(async () => {
    try {
      setStateLoading(true);
      const { data } = await get(API.GET_STATE_LIST);
      setStateLoading(false);
      setStateList(data.data);
    } catch (e) {
      setStateList([]);
      setStateLoading(false);
    }
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  return {
    stateList,
    stateLoading,
  };
};

export const useSuburbList = () => {
  const [suburbList, setSuburbList] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [suburbLoading, setSuburbLoading] = useState(false);
  const init = useCallback(async () => {
    try {
      if (selectedState) {
        setSuburbLoading(true);
        const { data } = await get(
          `${API.GET_SUBURB_LIST}?state=${selectedState}`
        );
        setSuburbLoading(false);
        setSuburbList(data.data);
      }
    } catch (e) {
      setSuburbList([]);
      setSuburbLoading(false);
    }
  }, [selectedState]);

  useEffect(() => {
    init();
  }, [init]);

  return {
    suburbList,
    handleStateSelect: (value) => {
      setSuburbList([]);
      setSelectedState(value);
    },
    suburbLoading,
    setSuburbList,
    selectedState,
  };
};

export const useSuburbListE = (id) => {
  const [suburbList, setSuburbList] = useState([]);
  const [shippingSuburbList, setShippingSuburbList] = useState([]);
  const [suburbLoading, setSuburbLoading] = useState(false);
  const init = useCallback(async () => {
    try {
      if (id) {
        setSuburbLoading(true);
        const { data } = await get(`${API.GET_SUBURB_LIST}?state=${id}`);
        setSuburbLoading(false);
        setSuburbList(data.data);
        setShippingSuburbList(data.data);
      }
    } catch (e) {
      setSuburbList([]);
      setShippingSuburbList([]);
      setSuburbLoading(false);
    }
  }, [id]);

  useEffect(() => {
    init();
  }, [init]);

  return {
    suburbList,
    suburbLoading,
    shippingSuburbList,
    setSuburbList,
    setShippingSuburbList,
  };
};
